import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as DragAndDrop} from "assets/img/drag-and-drop.svg";
import {greyishBlue300} from "assets/jss/main";

DragAndDropIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(DragAndDrop)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'circle': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true &&  {
            stroke: greyishBlue300
        }
    },
}));

export default function DragAndDropIcon(props) {
    return <StyledSvg {...props} />;
}
